export function generarRecibo( pago ){
  window.console.log( window.stringifyObject(pago) )
  var doc = new window.jsPDF({ orientation: 'p',
    unit: 'px',
    format: 'letter',
    fontSize: 10,
    putOnlyUsedFonts:false 
  }); 
  doc.cellInitialize();

  /*doc.rect(1, 1, 3, 3);
  doc.text( 'This text is centered\raround\rthis point.', 4, 2, 'center' );*/

  var elementHTML = window.$('#recibito').html();
  window.console.log( elementHTML );
  var specialElementHandlers = {
    '#elementH': function (/*element, renderer*/) {
      return true;
    }
  };
  doc.fromHTML(elementHTML, 15, 15, {
    'width': 300,
    'elementHandlers': specialElementHandlers
  });

  setTimeout( function(){
    doc.output("dataurlnewwindow");
  },500)

  
}


